import { getCurrentUser } from 'site-modules/shared/components/profile/firebase-auth';
import { logger } from 'client/utils/isomorphic-logger';

export const getAuthorizationToken = async () =>
  getCurrentUser()
    .then(currentUser => currentUser && currentUser.getIdToken())
    .catch(e => {
      logger('error', `Failed to retrieve user's inside ID token - ${e.message || e}`);
      return null;
    });
